import RecommendationItem from "./RecommendationItem";

export default RecommendationItem;
